import { useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AppContext } from '@/App';

// Deliberately local state only: every mount/open issues a fresh request.
export const useProjectDirectory = ({ includeCompleted = false, enabled = true, refreshKey = 0 } = {}) => {
  const { API } = useContext(AppContext);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision((v) => v + 1), []);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    setLoading(true);
    setError('');
    axios.get(`${API}/projects/directory`, {
      params: { includeCompleted }, headers: { 'Cache-Control': 'no-cache' },
    }).then(({ data }) => {
      if (active) setProjects(data);
    }).catch(() => {
      if (active) { setProjects([]); setError('Could not load projects. Please retry.'); }
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [API, includeCompleted, enabled, refreshKey, revision]);

  return { projects, loading, error, refresh };
};